
  export const NOTIFICATIONTYPES_RECEIVED = "NOTIFICATIONTYPES_RECEIVED";
  export const SET_NOTIFICATIONTYPE = "SET_NOTIFICATIONTYPE";
  export const CREATE_NOTIFICATIONTYPE = "CREATE_NOTIFICATIONTYPE";
  export const SET_PROPERTY_NOTIFICATIONTYPE = "SET_PROPERTY_NOTIFICATIONTYPE";
  